import { useDemoStore } from "../pinia/index";
const store = useDemoStore()

//解密函数,val传需要解密的文本
export function Kernaldec(val) {
    if (window.kernaldec) {
        if (val) {
            return window.kernaldec.decode(
                val,
                store.user_uid,
                store.token
            )
        } else {
            return val
        }
    } else {
        return val
    }
}



//加密，val传需要解密的文本
export function encode(val) {
    if (window.kernaldec) {
        if (val) {
            return window.kernaldec.encode(
                val,
                store.user_uid,
                store.token
            )
        }
    } else {
        return val
        // return this.$baseMessage('未触发函数!失败', 'warning', 'warning')
    }
}
